import React, { useState, useEffect } from "react";
import { adminCreateBanner, adminUpdateBanner } from "../api/admin";
import ImageUpload from "./ImageUpload";
import { toast } from "react-toastify";

const BannerForm = ({ banner, onSuccess, onCancel }) => {
  const [title, setTitle] = useState("");
  const [smallText, setSmallText] = useState("");
  const [images, setImages] = useState([]); // Array of { url, file }
  const [isActive, setIsActive] = useState(true);

  // ✅ reset helper (same pattern as ProductForm)
  const resetForm = () => {
    setTitle("");
    setSmallText("");
    setImages([]);
    setIsActive(true);
  };

  // ✅ Populate form when editing
  useEffect(() => {
    if (banner) {
      setTitle(banner.title || "");
      setSmallText(banner.smallText || "");
      setIsActive(banner.isActive ?? true);
      const bannerImg = banner.image;
      const imageUrl = (typeof bannerImg === 'object' && bannerImg !== null) ? bannerImg.url : bannerImg;
      setImages(imageUrl ? [{ url: imageUrl, file: null }] : []);
    } else {
      resetForm();
    }
  }, [banner]);

  const handleAddImages = (files) => {
    const file = files[0];
    if (file) {
      setImages([{
        url: URL.createObjectURL(file),
        file: file
      }]);
    }
  };

  const removeImage = () => {
    setImages(prev => {
      if (prev.length > 0 && prev[0].file) {
        URL.revokeObjectURL(prev[0].url);
      }
      return [];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("smallText", smallText);
    formData.append("isActive", isActive);

    if (images.length > 0) {
      if (images[0].file) {
        formData.append("image", images[0].file);
      }
      // Do not append string URL for existing images to avoid Pydantic value_error
    }

    try {
      if (banner?.id || banner?._id) {
        const bannerId = banner._id || banner.id;
        await adminUpdateBanner(bannerId, formData);
        toast.success("Banner updated successfully! ✨");
      } else {
        await adminCreateBanner(formData);
        toast.success("Banner created successfully! 🖼️");
      }

      resetForm();
      onSuccess();
    } catch (err) {
      console.error("Error saving banner:", err);
      toast.error(err.response?.data?.message || "Failed to save banner. ❌");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="form-body">
        <div className="form-grid">
          <div className="form-group">
            <label>Banner Title <span className="required-star">*</span></label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter banner title"
              required
            />
          </div>

          <div className="form-group">
            <label>Small Text</label>
            <input
              value={smallText}
              onChange={(e) => setSmallText(e.target.value)}
              placeholder="Enter subtitle or small text"
            />
          </div>

          <div className="form-group full-width">
            <label>Banner Image <span className="required-star">*</span></label>
            <ImageUpload
              images={images}
              onAdd={handleAddImages}
              onRemove={removeImage}
              multiple={false}
              id="banner-image-upload"
            />
          </div>
        </div>

        <div className="offer-options">
          <label className="checkbox-card">
            <input
              type="checkbox"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />
            <span>Active Status</span>
          </label>
        </div>
        <div className="form-footer">
          <button type="submit" className="btn-submit">
            {banner ? "Update Banner" : "Save Banner"}
          </button>
          <button
            type="button"
            className="btn-cancel"
            onClick={() => {
              resetForm();
              onCancel();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};

export default BannerForm;
